import { Platform } from "react-native";
import { default as AndroidPicker } from "./AndroidPicker";
import { default as IOSPicker } from "./IOSPicker";
import { default as OffDutyPickerSheet } from "./PickerSheet";
const Picker = Platform.OS === "ios" ? IOSPicker : AndroidPicker;

export { OffDutyPickerSheet };
export default Picker;
